var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVideo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.17969 13.1929H45.2109V40.4429C45.2109 41.3022 44.5078 42.0054 43.6484 42.0054H6.74219C5.88281 42.0054 5.17969 41.3022 5.17969 40.4429V13.1929Z",
    fill: "white",
    stroke: "#000105",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.74219 8.896H43.6484C44.5078 8.896 45.2109 9.62799 45.2109 10.5226V14.7519H5.17969V10.5226C5.17969 9.62799 5.88281 8.896 6.74219 8.896Z",
    fill: "#000105",
    stroke: "#000105",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.82031 12.5991C10.3208 12.5991 10.7266 12.1934 10.7266 11.6929C10.7266 11.1924 10.3208 10.7866 9.82031 10.7866C9.3198 10.7866 8.91406 11.1924 8.91406 11.6929C8.91406 12.1934 9.3198 12.5991 9.82031 12.5991Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5391 12.5991C13.0396 12.5991 13.4453 12.1934 13.4453 11.6929C13.4453 11.1924 13.0396 10.7866 12.5391 10.7866C12.0386 10.7866 11.6328 11.1924 11.6328 11.6929C11.6328 12.1934 12.0386 12.5991 12.5391 12.5991Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4942 10.7866H24.0098C22.8223 10.7866 22.8067 12.6147 24.0098 12.6147H41.4942C42.6817 12.6147 42.6973 10.7866 41.4942 10.7866Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1953 37.9058C30.373 37.9058 34.5703 33.7084 34.5703 28.5308C34.5703 23.3531 30.373 19.1558 25.1953 19.1558C20.0176 19.1558 15.8203 23.3531 15.8203 28.5308C15.8203 33.7084 20.0176 37.9058 25.1953 37.9058Z",
    fill: "#8CC947",
    stroke: "#000105",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7109 28.2337C28.9297 28.3587 28.9297 28.6868 28.7109 28.8118L25.7422 30.5306L22.7734 32.2493C22.5547 32.3743 22.2734 32.2181 22.2734 31.9524V25.0774C22.2734 24.8274 22.5547 24.6556 22.7734 24.7806L25.7422 26.4993L28.7109 28.2181V28.2337Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.149a797c999af039fc883ea8511970df.svg";
export { ForwardRef as ReactComponent };